export const SYMBOLS = {
	heart: ']',
	couple: '[',
	infinity: '^',
};

export const getFontCssClass = (font: string) =>
	font
		? `font-${font.toLowerCase().replace(' ', '-')}`
		: '';

export const isSpecialCharacter = (symbol: string) =>
	Object.values(SYMBOLS).includes(symbol);
